import coverImg from '../../../assets/images/literature/signal-tower-cover.jpg';

const SEGMENTS = [
    {
        id: 'signal-tower-1',
        title: 'Loneliness and Fear',
        text: `"I get afraid when you leave me alone this way at night."
The big man, Tolliver, patted his wife's head. His coarse laughter was meant to reassure, but his eyes were uneasy. The little boy crouched by the cook-stove, whimpering over the remains of his supper.
"What are you afraid of?" Tolliver scoffed.
"He's afraid, too, when the sun goes down."
For a time Tolliver listened to the wind, which assaulted the frame house with the furious voices of witches demanding admittance.`,
        morseText: '| | | I GET AFRAID WHEN YOU LEAVE ME ALONE THIS WAY AT NIGHT BK THE BIG MAN TOLLIVER PATTED HIS WIFES HEAD BK HIS COARSE LAUGHTER WAS MEANT TO REASSURE BUT HIS EYES WERE UNEASY BK THE LITTLE BOY CROUCHED BY THE COOK STOVE WHIMPERING OVER THE REMAINS OF HIS SUPPER BK WHAT ARE YOU AFRAID OF TOLLIVER SCOFFED BK HES AFRAID TOO WHEN THE SUN GOES DOWN BK FOR A TIME TOLLIVER LISTENED TO THE WIND WHICH ASSAULTED THE FRAME HOUSE WITH THE FURIOUS VOICES OF WITCHES DEMANDING ADMITTANCE BK',
        estimatedSeconds: { wpm15: 180, wpm20: 135, wpm25: 108 },
        questions: [
            {
                id: 'signal-tower-q1',
                question: 'What does the wind sound like to the family?',
                options: ['STAMPEDING HORSES', 'FURIOUS WITCHES', 'A RUNAWAY TRAIN', 'WHISPERING VOICES'],
                answer: 'FURIOUS WITCHES',
                difficulty: 'Beginner'
            }
        ]
    },
    {
        id: 'signal-tower-2',
        title: 'The Trouble with Joe',
        text: `"You're afraid of Joe," he said wearily.
"He came last night after you relieved him at the tower. He knocked, and I wouldn't let him in. He threatened. He said he'd show us we couldn't kick him out of the house just because he couldn't help liking me. We never ought to have let him board here at all."
"Don't you worry about Joe, Sally, I'll talk to him now, before I let him out of the tower. He's due to relieve me again at midnight."
"Don't go away, papa," the child spoke.`,
        morseText: '| | YOURE AFRAID OF JOE HE SAID WEARILY BK HE CAME LAST NIGHT AFTER YOU RELIEVED HIM AT THE TOWER BK HE KNOCKED AND I WOULDNT LET HIM IN BK HE THREATENED BK HE SAID HED SHOW US WE COULDNT KICK HIM OUT OF THE HOUSE JUST BECAUSE HE COULDNT HELP LIKING ME BK WE NEVER OUGHT TO HAVE LET HIM BOARD HERE AT ALL BK\DONT YOU WORRY ABOUT JOE SALLY I WILL TALK TO HIM NOW BEFORE I LET HIM OUT OF THE TOWER BK HE IS DUE TO RELIEVE ME AGAIN AT MIDNIGHT BK DONT GO AWAY PAPA THE CHILD SPOKE BK',
        estimatedSeconds: { wpm15: 190, wpm20: 142, wpm25: 114 },
        questions: [
            {
                id: 'signal-tower-q2',
                question: 'Who is the man Sally is afraid of?',
                options: ['THE SUPERINTENDENT', 'JOE', 'THE ENGINEER', 'A TRAMP'],
                answer: 'JOE',
                difficulty: 'Beginner'
            }
        ]
    },
    {
        id: 'signal-tower-3',
        title: 'The Tower Meeting',
        text: `Tolliver took the child by the hand and led him into the wind-haunted darkness. It was only a short distance to the single track railroad and the signal tower.
When Tolliver's head was above the level of the flooring he could see the switch levers, and the table, gleaming with the telegraph instruments. Joe was as large as Tolliver, and younger. 
"Here at last, eh?" a surly voice came down.
"That's one thing I want to say to you, Joe. Just you keep away from the house."`,
        morseText: '| | TOLLIVER TOOK THE CHILD BY THE HAND AND LED HIM INTO THE WIND HAUNTED DARKNESS BK IT WAS ONLY A SHORT DISTANCE TO THE SINGLE TRACK RAILROAD AND THE SIGNAL TOWER BK WHEN TOLLIVERS HEAD WAS ABOVE THE LEVEL OF THE FLOORING HE COULD SEE THE SWITCH LEVERS AND THE TABLE BK GLEAMING WITH THE TELEGRAPH INSTRUMENTS BK JOE WAS AS LARGE AS TOLLIVER AND YOUNGER BK HERE AT LAST EH A SURLY VOICE CAME DOWN BK THATS ONE THING I WANT TO SAY TO YOU JOE BK JUST YOU KEEP AWAY FROM THE HOUSE BK',
        estimatedSeconds: { wpm15: 200, wpm20: 150, wpm25: 120 },
        questions: []
    },
    {
        id: 'signal-tower-4',
        title: 'The Special and the Gun',
        text: `"Forgot," Joe said. "Some big-wigs coming through on a special train along about midnight. Keep awake."
Tolliver studied the yellow slips. Thirty-three was late, and still losing. He opened a drawer and drew out a polished six-shooter—railroad property. 
"Not to play with, Sonny. If you promise not to touch it 'till you get home and hand it to mama, tomorrow I'll give you a nickel."
The child commenced to run. Tolliver heard the sound of tiny feet scuffling with panic along the road toward home.`,
        morseText: '| | FORGOT JOE SAID BK SOME BIG WIGS COMING THROUGH ON A SPECIAL TRAIN ALONG ABOUT MIDNIGHT BK KEEP AWAKE BK TOLLIVER STUDIED THE YELLOW SLIPS BK THIRTY THREE WAS LATE AND STILL LOSING BK HE OPENED A DRAWER AND DREW OUT A POLISHED SIX SHOOTER RAILROAD PROPERTY BK NOT TO PLAY WITH SONNY BK IF YOU PROMISE NOT TO TOUCH IT TILL YOU GET HOME AND HAND IT TO MAMA TOMORROW I WILL GIVE YOU A NICKEL BK THE CHILD COMMENCED TO RUN BK TOLLIVER HEARD THE SOUND OF TINY FEET SCUFFLING WITH PANIC ALONG THE ROAD TOWARD HOME BK',
        estimatedSeconds: { wpm15: 210, wpm20: 157, wpm25: 126 },
        questions: [
            {
                id: 'signal-tower-q3',
                question: 'What bribe does Tolliver offer the boy to take the gun to his mother?',
                options: ['A CANDY BAR', 'A NICKEL', 'A SHINY STONE', 'A TOY TRAIN'],
                answer: 'A NICKEL',
                difficulty: 'Intermediate'
            }
        ]
    },
    {
        id: 'signal-tower-5',
        title: 'Watchful Waiting',
        text: `Tolliver's restlessness grew. He sat here, listening to every word beaten out by the sounder. He pictured his wife and son, alone in the little house.
"Allen reports special left Oldtown at 9.45."
More and more it became clear that the special and thirty-three would meet near his tower.
"NT. NT. NT. Is it storming bad with you?"
"Pretty thick."
"Then keep the fuses burning. For God's sake, don't let the first in over-run his switch."`,
        morseText: '| | TOLLIVERS RESTLESSNESS GREW BK HE SAT HERE LISTENING TO EVERY WORD BEATEN OUT BY THE SOUNDER BK HE PICTURED HIS WIFE AND SON ALONE IN THE LITTLE HOUSE BK ALLEN REPORTS SPECIAL LEFT OLDTOWN AT NINE FORTY FIVE BK MORE AND MORE IT BECAME CLEAR THAT THE SPECIAL AND THIRTY THREE WOULD MEET NEAR HIS TOWER BK NT NT NT IS IT STORMING BAD WITH YOU BK PRETTY THICK BK THEN KEEP THE FUSES BURNING BK FOR GODS SAKE DONT LET THE FIRST IN OVER RUN HIS SWITCH BK',
        estimatedSeconds: { wpm15: 200, wpm20: 150, wpm25: 120 },
        questions: [
            {
                id: 'signal-tower-q4',
                question: 'What special instruction does the supervisor give about the storm?',
                options: ['STOP ALL TRAINS', 'KEEP THE FUSES BURNING', 'CHECK THE TRACKS', 'CLOSE THE TOWER'],
                answer: 'KEEP THE FUSES BURNING',
                difficulty: 'Intermediate'
            }
        ]
    },
    {
        id: 'signal-tower-6',
        title: 'Joe Returns',
        text: `Someone was on the stairs, climbing with difficulty. Joe's face appeared, ugly and inflamed. Hatred was there. 
"Where you been?" Tolliver demanded fiercely.
"Don't you wish you knew?"
Tolliver straighted, facing an abominable choice. Joe lurched to the table, fumbling aimlessly. He sat on the floor with his back against the wall, his head drooping.
"To keep Sally company," Joe laughed happily, "while you look after the special and thirty-three."`,
        morseText: '| | SOMEONE WAS ON THE STAIRS CLIMBING WITH DIFFICULTY BK JOES FACE APPEARED UGLY AND INFLAMED BK HATRED WAS THERE BK WHERE YOU BEEN TOLLIVER DEMANDED FIERCELY BK\DONT YOU WISH YOU KNEW BK TOLLIVER STRAIGHTENED FACING AN ABOMINABLE CHOICE BK JOE LURCHED TO THE TABLE FUMBLING AIMLESSLY BK HE SAT ON THE FLOOR WITH HIS BACK AGAINST THE WALL HIS HEAD DROOPING BK TO KEEP SALLY COMPANY JOE LAUGHED HAPPILY WHILE YOU LOOK AFTER THE SPECIAL AND THIRTY THREE BK',
        estimatedSeconds: { wpm15: 190, wpm20: 142, wpm25: 114 },
        questions: []
    },
    {
        id: 'signal-tower-7',
        title: 'The Confrontation',
        text: `Tolliver sprang then, but Joe avoided the heavier man. Joe grasped a chair and brought it down. It splintered on Tolliver's head. He fell to his knees, reaching out blindly.
"NT. NT. NT. Thirty-three cleared LR at 12.47."
"NT. NT. NT. Special cleared JV at 12.48."
Each rushing towards each other with only a minute's difference!
"Papa! Come quick! Come quick!"
The child crawled up the steps on his hands and knees.`,
        morseText: '| | TOLLIVER SPRANG THEN BUT JOE AVOIDED THE HEAVIER MAN BK JOE GRASPED A CHAIR AND BROUGHT IT DOWN BK IT SPLINTERED ON TOLLIVERS HEAD BK HE FELL TO HIS KNEES REACHING OUT BLINDLY BK NT NT NT THIRTY THREE CLEARED LR AT TWELVE FORTY SEVEN BK NT NT NT SPECIAL CLEARED JV AT TWELVE FORTY EIGHT BK EACH RUSHING TOWARDS EACH OTHER WITH ONLY A MINUTES DIFFERENCE BK PAPA COME QUICK COME QUICK COME QUICK BK THE CHILD CRAWLED UP THE STEPS ON HIS HANDS AND KNEES BK',
        estimatedSeconds: { wpm15: 220, wpm20: 165, wpm25: 132 },
        questions: [
            {
                id: 'signal-tower-q5',
                question: 'What weapon did Joe use to hit Tolliver?',
                options: ['A LEAD PIPE', 'A CHAIR', 'A TELEGRAPH KEY', 'THE SIX SHOOTER'],
                answer: 'A CHAIR',
                difficulty: 'Intermediate'
            }
        ]
    },
    {
        id: 'signal-tower-8',
        title: 'Sonny Returns',
        text: `"Papa, come quick. Joe broke down the door. Mama had the gun locked in the cupboard. Joe grabbed mama, and she screamed, and said to run and make you come."
From far to the south drifted the whistle of the special. To the north, thirty-three's glow increased. It was cutting it too close. What good would it do him to kill Joe now?
The last black Pullman of thirty-three cleared the points. With a gasping breath Tolliver threw the switch lever.`,
        morseText: '| | PAPA COME QUICK BK JOE BROKE DOWN THE DOOR BK MAMA HAD THE GUN LOCKED IN THE CUPBOARD BK JOE GRABBED MAMA AND SHE SCREAMED AND SAID TO RUN AND MAKE YOU COME BK FROM FAR TO THE SOUTH DRIFTED THE WHISTLE OF THE SPECIAL BK TO THE NORTH THIRTY THREES GLOW INCREASED BK IT WAS CUTTING IT TOO CLOSE BK WHAT GOOD WOULD IT DO HIM TO KILL JOE NOW BK THE LAST BLACK PULLMAN OF THIRTY THREE CLEARED THE POINTS BK WITH A GASPING BREATH TOLLIVER THREW THE SWITCH LEVER BK',
        estimatedSeconds: { wpm15: 210, wpm20: 157, wpm25: 126 },
        questions: []
    },
    {
        id: 'signal-tower-9',
        title: 'The Aftermath',
        text: `A hot, white eye flashed by, and a blurred streak of cars. The tower shook. 
"What ails you, Tolliver?" the engineer asked.
"I guess maybe my wife at the house is dead."
Someone else was on the stairs now, climbing with extreme slowness. A bare arm reached through the trap.
"Don't touch me," she whispered. "What am I going to do? I had to. I killed him."
The revolver dangled from her fingers. It fell to the floor.`,
        morseText: '| | A HOT WHITE EYE FLASHED BY AND A BLURRED STREAK OF CARS BK THE TOWER SHOOK BK WHAT AILS YOU TOLLIVER THE ENGINEER ASKED BK I GUESS MAYBE MY WIFE AT THE HOUSE IS DEAD BK SOMEONE ELSE WAS ON THE STAIRS NOW CLIMBING WITH EXTREME SLOWNESS BK A BARE ARM REACHED THROUGH THE TRAP BK\DONT TOUCH ME SHE WHISPERED BK WHAT AM I GOING TO DO BK I HAD TO BK I KILLED HIM BK THE REVOLVER DANGLED FROM HER FINGERS BK IT FELL TO THE FLOOR BK',
        estimatedSeconds: { wpm15: 200, wpm20: 150, wpm25: 120 },
        questions: [
            {
                id: 'signal-tower-q6',
                question: 'What news does Sally bring to the tower?',
                options: ['THAT SHE IS LEAVING', 'THAT THE HOUSE IS ON FIRE', 'THAT SHE KILLED JOE', 'THAT SHE IS AFRAID'],
                answer: 'THAT SHE KILLED JOE',
                difficulty: 'Advanced'
            }
        ]
    },
    {
        id: 'signal-tower-10',
        title: 'Measureless Relief',
        text: `Tolliver went to the table and commenced to tap on the key. 
"What you telling them?" she demanded.
"To send another man now Joe is gone. If I hadn't stayed! If I'd let them smash! When all along it only needed Joe to keep all those people from getting killed."
He held her close. While the boy slept, they waited together for someone to take Joe's place.`,
        morseText: '| | TOLLIVER WENT TO THE TABLE AND COMMENCED TO TAP ON THE KEY BK WHAT YOU TELLING THEM SHE DEMANDED BK TO SEND ANOTHER MAN NOW JOE IS GONE BK IF I HADNT STAYED BK IF ID LET THEM SMASH BK WHEN ALL ALONG IT ONLY NEEDED JOE TO KEEP ALL THOSE PEOPLE FROM GETTING KILLED BK HE HELD HER CLOSE BK WHILE THE BOY SLEPT THEY WAITED TOGETHER FOR SOMEONE TO TAKE JOES PLACE BK',
        estimatedSeconds: { wpm15: 160, wpm20: 120, wpm25: 96 },
        questions: []
    }
];

export default {
    id: 'story-the-signal-tower',
    type: 'story',
    title: 'The Signal Tower',
    author: 'Wadsworth Camp',
    publicationDate: '1920',
    coverImage: coverImg,
    genres: ['Railroad Fiction', 'Thriller', 'Telegraphy', 'Communication', 'Morse Code'],
    characterLength: SEGMENTS.reduce((acc, s) => acc + s.text.length, 0),
    description: "A high-stakes thriller where a signal tower operator must choose between his family and a train full of passengers.",

    text: SEGMENTS.map(s => s.text).join('\n\n'),
    comprehensionQuestions: SEGMENTS.flatMap(s => s.questions),
    segments: SEGMENTS.map(s => ({
        ...s,
        comprehensionQuestions: s.questions.map(q => q.id)
    })),

    metadata: {
        setting: 'Remote Signal Tower / Single Track Railroad',
        period: '1920',
        themes: ['Responsibility', 'Duty', 'Protection', 'Violence'],
        difficulty: 'Advanced',
        estimatedReadingTimeMinutes: 12,
        segments: 10
    }
};
